export const API_ENDPOINTS = {
    INVOICE: {
        SEARCH_INVOICE: "Invoice/Search",
        SEARCH_UPDATE: "Invoice/UpdateStatus",
       GET_INVOICE_ITEM: "Invoice/GetInvoiceItem",

  },
 
  // Add other modules like EMPLOYEE, DEPARTMENT etc.
};

export const QUERY_KEYS = {
    INVOICE: {
        INVOICE: ["SearchInvoice"], // UNIQUE IN OVER ALL APPLICATION
  },
  
};